// base path for client hub management settings
export const clientHubManagementPath = '/settings/admin/clienthub';

// client hub management sub-paths
export const clientHubAccessPath = clientHubManagementPath + '/clienthubaccess';
export const clientHubServiceTeamsPath = clientHubManagementPath + '/serviceteams';
export const clientHubCustomFieldsPath = clientHubManagementPath + '/customfields';
